// Convertible instruments (SAFEs/notes) — PSD §3.2, F1.6. Engine layer (framework-free).
/**
 * As-converted shares for a convertible at a given exit equity value.
 * Uses the more favorable of (discount to equity value) or (valuation cap).
 */
export function asConvertedSharesForConvertible(conv, equityValueAtExit, fdSharesWithoutConvertibles) {
    // Valuation-cap path: shares = principal / (cap / (cap/FD + principal))? Use cap-implied price.
    // Discount path: conversion price = equityValue / FD * (1 - discount)
    if (equityValueAtExit <= 0 || fdSharesWithoutConvertibles <= 0)
        return 0;
    const marketPrice = equityValueAtExit / fdSharesWithoutConvertibles;
    let convPrice = marketPrice * (1 - conv.discount); // discount path
    if (conv.valuationCap && conv.valuationCap > 0) {
        const capPrice = conv.valuationCap / fdSharesWithoutConvertibles;
        convPrice = Math.min(convPrice, capPrice); // cap gives lower price = more shares
    }
    if (convPrice <= 0)
        return 0;
    // Principal accrues interest for notes (SAFEs have 0 interest)
    const accrued = conv.principal * (1 + conv.interestRate);
    return accrued / convPrice;
}
/** Total as-converted shares from all convertibles at a given exit. */
export function asConvertedShares(cap, equityValueAtExit) {
    const fdWithout = cap.instruments.reduce((s, i) => {
        if (i.kind === 'common' || i.kind === 'preferred' || i.kind === 'option' || i.kind === 'warrant' || i.kind === 'rsu' || i.kind === 'pool') {
            return s + (i.kind === 'pool' ? i.sharesAuthorized - i.sharesOutstanding : i.sharesOutstanding);
        }
        return s;
    }, 0);
    return cap.convertibles.reduce((s, c) => s + asConvertedSharesForConvertible(c, equityValueAtExit, Math.max(1, fdWithout)), 0);
}
/** Convertible-conversion breakpoints to insert into the breakpoint schedule. */
export function convertibleBreakpoints(cap) {
    // The conversion happens when the convertible is in-the-money at exit.
    // For OPM, the convertible effectively dilutes common at the cap-implied threshold.
    const out = [];
    for (const c of cap.convertibles) {
        if (c.valuationCap && c.valuationCap > 0) {
            out.push({ strike: c.valuationCap, cause: `convertible:${c.name}` });
        }
    }
    return out;
}
//# sourceMappingURL=convertibles.js.map